module.exports = __webpack_public_path__ + "media/images/athletes/4326-866a2a57dbc67fa768a7a078d69f4d91.png";